<template>
  <div>
    <form
      @submit.prevent="handleSubmit()"
      class="reset-password-form"
    >
      <h1
        class="h3 mb-3 text-center font-weight-normal"
      >Reset FetchRev WiFi Password</h1>
      <div class="text-center">
        <p>Please provide the email address associated with your FetchRev WiFi Account.
          <br>We will email you instructions how to reset your password.
        </p>
      </div>

      <div
        :class="{'has-error': $v.email.$error}"
        class="form-group"
      >
        <label
          class="sr-only"
          for="inputEmail"
        >Email</label>
        <input
          autofocus
          class="form-control"
          id="inputEmail"
          placeholder="Email address"
          type="email"
          v-model.trim="$v.email.$model"
        >
        <small
          class="error"
          v-show="$v.email.$error"
        >
          <template v-if="!$v.email.required">Email is required.</template>
          <template v-else-if="!$v.email.email">Invalid email.</template>
        </small>
      </div>
      <button
        @click="handleSubmit()"
        class="btn btn-lg btn-primary btn-block col col-3 ml-auto"
        type="button"
      >Submit</button>
    </form>
  </div>
</template>

<script>

import { required, email } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      email: '',
      password: '',
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    handleSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.submitEmail(this.email, this.password);
      }
    },
    submitEmail(username, password) {
      this.$store.dispatch('requestAuth', { username, password }).then(() => {
        this.$router.push('/');
      }).catch((err) => {
        this.$toast('error', err.message);
      });
    },
  },
};
</script>

<style lang="scss">
.reset-password-form {
  padding: 24px;
  background: #ffffff;
}

.form-body {
  padding-top: 1.5rem;
}
</style>
